const getEnvFromHost = () => {
  const host = window.location.host;

  if (host.includes('localhost') || host.includes('127.0.0.1')) {
    return 'local';
  }

  if (host.includes('riverisland.com')) {
    return 'production';
  }

  if (host.includes('ripreprod.com')) {
    return 'preprod';
  }
  if (host.includes('ripostprod.com')) {
    return 'postprod';
  }

  const uatMatch = host.match(/uat(\d+)\.riuat\.com/);
  if (uatMatch) {
    return `uat${uatMatch[1]}`;
  }

  return host;
};

export default getEnvFromHost;
